import gettext from '../../lang/gettext';
import { addSuffix } from '../../utils';

function getAvailableShiftWithoutApplicantsStatus(shift, options) {
  if (options.isPendingAcceptance) {
    if (shift.user?.isMe) {
      return gettext('This shift is available while waiting for your acceptance.');
    }

    const name = shift.user?.fullname ? addSuffix(shift.user.fullname) : ''; // @TODO: gettextPosessive
    return gettext('This shift is available while waiting for %(fullname)s acceptance.', {
      fullname: name,
    });
  }

  if (options.isRejected) {
    const fullname = shift.user?.fullname || gettext('Employee');
    return shift.user?.isMe
      ? gettext('You have denied this shift.\nWaiting for someone to take it.')
      : gettext('%(fullname)s has denied this shift.\nWaiting for someone to take it.', {
          fullname,
        });
  }

  return shift.user?.isMe
    ? gettext('You have made this shift available.\nWaiting for someone to take it.')
    : gettext('This shift is available.\nWaiting for someone to take it.');
}

export function getAvailableShiftStatus(shift, currentUser, options = {}) {
  if (!shift.available) {
    return '';
  }

  const applicantsCount = shift?.applications?.length || 0;
  const pendingPostfix = gettext("\nWaiting for manager's approval.");
  if (!applicantsCount) {
    return getAvailableShiftWithoutApplicantsStatus(shift, options);
  }

  if (!currentUser.isManager) {
    return getEmployeeAvailabilityStatus(shift, pendingPostfix);
  }

  if (shift.myApplication) {
    let suffix = '';
    if (applicantsCount === 2) {
      const name = shift.applications.find((a) => !a.user.isMe).user.name;
      suffix = gettext('You and %(name)s have applied for this shift.', { name });
    } else if (applicantsCount > 2) {
      suffix = gettext('You and %(count)s others have applied for this shift.', {
        count: applicantsCount - 1,
      });
    } else {
      suffix = gettext('You have applied for this shift.');
    }

    return `${suffix}${pendingPostfix}`;
  }

  if (applicantsCount === 1) {
    const suffix = gettext('%(name)s has applied for this shift.', {
      name: shift.applications[0].user.name,
    });
    return `${suffix}${pendingPostfix}`;
  }

  return `${gettext('%(count)s employees have applied for this shift.', {
    count: applicantsCount,
  })}${pendingPostfix}`;
}

function getEmployeeAvailabilityStatus(availableShift, postfix = '') {
  let applicantsCountToDisplay = availableShift?.applications?.length || 0;
  if (availableShift.myApplication) {
    if (applicantsCountToDisplay < 2) {
      return `${gettext('You have applied for this shift.')}${postfix}`;
    }

    applicantsCountToDisplay -= 1;
    if (applicantsCountToDisplay > 1) {
      return `${gettext('You and %(count)s coworkers applied for this shift.', {
        count: applicantsCountToDisplay,
      })}${postfix}`; // @TODO: gettextPlural
    }

    return `${gettext('You and 1 coworker applied for this shift.')}${postfix}`;
  }

  if (applicantsCountToDisplay > 1) {
    return `${gettext('%(count)s coworkers applied for this shift.', {
      count: applicantsCountToDisplay,
    })}${postfix}`; // @TODO: gettextPlural
  }

  return `${gettext('1 coworker applied for this shift.')}${postfix}`;
}
